var _defs, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLcsAirWaterOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Connected_in_use_Air_and_Water_OFF",
    "data-name": "Connected + in use_Air and Water OFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ce398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37cf4b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3901",
    "data-name": "Path 3901",
    d: "M37.18,42.83H7.12A5.826,5.826,0,0,1,1.3,37.01V7.12A5.819,5.819,0,0,1,7.12,1.3H37.18A5.819,5.819,0,0,1,43,7.12V37.01A5.826,5.826,0,0,1,37.18,42.83Z",
    fill: "#404041"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3902",
    "data-name": "Path 3902",
    d: "M38.01,11.8a2.057,2.057,0,0,0-2.43.53L29.72,10.9l.45-.94a2.5,2.5,0,0,0-1.9-2.64L18.25,4.88a2.258,2.258,0,0,0-2.67,1.61l-.86,4.01a2.5,2.5,0,0,0,1.91,2.63l1.7.42-5.4,18.38L7.72,42.83H20.18l2.91-6.08.22-.47,2.11-20.32a1.728,1.728,0,0,0,.2-.86l.86.41a2.258,2.258,0,0,0,2.67-1.61l.18-1.26,6.03,1.52a2.247,2.247,0,0,0,2.19,1.35,1.854,1.854,0,0,0,1.79-1.57A2.107,2.107,0,0,0,38.01,11.8Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    d: "M37.15,44.13h-30A7.151,7.151,0,0,1,0,37V7.12A7.149,7.149,0,0,1,7.15,0h30A7.149,7.149,0,0,1,44.3,7.12V37A7.151,7.151,0,0,1,37.15,44.13ZM7.15,2.6A4.535,4.535,0,0,0,2.61,7.13V37a4.541,4.541,0,0,0,4.54,4.53h30A4.535,4.535,0,0,0,41.69,37V7.12a4.541,4.541,0,0,0-4.54-4.53h-30Z",
    fill: "#2db439"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9859",
    "data-name": "Group 9859",
    transform: "translate(-8155.12 -1318.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9443",
    "data-name": "Group 9443",
    transform: "translate(8183 1346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9439",
    "data-name": "Group 9439",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 12.56,
    cy: 12.56,
    rx: 12.56,
    ry: 12.56,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Checkbox",
    d: "M6.844,11.761,0,5,1.389,3.626,6.844,8.919,15.871,0,17.26,1.372Z",
    transform: "translate(8187.082 1352.68)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcsAirWaterOff);
export default __webpack_public_path__ + "static/media/lcs_air_water_off.8eb784d0591ddf5d8bc5828f30213d85.svg";
export { ForwardRef as ReactComponent };